import React from 'react';
import {View} from 'react-native';
import {SwitchProps} from '../../../data/types/interface/input';
import DeclarerSuiviMenu from '../DeclarerSuiviMenu';
import Label from '../Label';

export const CustomSwitch = ({
  name = '',
  label = '',
  typeLabel = 'titleGreen11',
  onChange,
  required = false,
  error = '',
  showError = false,
  style = {},
  value = false,
  disabled = false,
}: SwitchProps) => {
  const handleChange = (newValue: boolean) => {
    if (!disabled) {
      typeof onChange === 'function' && name && onChange(name, newValue, true);
    }
  };

  return (
    <View style={[{marginTop: 10, marginBottom: 20}, style]}>
      <View
        style={{
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}>
        <Label title={`${label} ${required ? '*' : ''}`} type={typeLabel} />
        <DeclarerSuiviMenu
          active={value}
          callBack={handleChange}
          type="switch"
          label1={'Oui'}
          label2={'Non'}
          value1={true}
          value2={false}
        />
      </View>
      {!disabled && error && showError ? (
        <Label title={error} type="error" />
      ) : null}
    </View>
  );
};
